import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { 
  FaUser, 
  FaInstagram, 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn 
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";
import "./footer.css";

const Footer = () => {
  const [user, setUser] = useState(null);
  const currentYear = new Date().getFullYear();

  // Recupera el usuario desde localStorage al montar el componente
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <footer className="footer">
      <div className="footer-links">
        {user ? (
          <Link to="/mi-cuenta" className="footer-button">
            <FaUser style={{ marginRight: "5px" }} />
            Hola, {user.nombre || user.username}
          </Link>
        ) : (
          <Link to="/login" className="footer-button">
            REGÍSTRATE / INICIA SESIÓN
          </Link>
        )}
        <Link to="/contacto" className="footer-button">
          CONTÁCTANOS
        </Link>
        <Link to="/planes" className="footer-button">
          PLANES
        </Link>
        <Link to="/nosotros" className="footer-button">
          NOSOTROS
        </Link>
      </div>

      {/* Sección de íconos sociales */}
      <div className="footer-social">
        <a
          href="https://www.instagram.com/workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="footer-social-icon">
            <FaInstagram />
          </div>
        </a>
        <a
          href="https://www.facebook.com/workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="footer-social-icon">
            <FaFacebookF />
          </div>
        </a>
        <a
          href="https://www.tiktok.com/@workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="footer-social-icon">
            <SiTiktok />
          </div>
        </a>
        <a
          href="https://x.com/workingunidos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="footer-social-icon">
            <FaTwitter />
          </div>
        </a>
        <a
          href="https://www.linkedin.com/company/workingunidos/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="footer-social-icon">
            <FaLinkedinIn />
          </div>
        </a>
      </div>

      <div className="footer-bottom">
        <p>
          Copyright {currentYear} – WorkingUnidos. Todos los Derechos Reservados.
        </p>
        <p>
          Página Web desarrollada por{" "}
          <a
            href="https://www.visiongorilla.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            VisionGorilla Digital Agency
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;